import { Component, Input } from '@angular/core';
import { ComponentData, ComponentDataSelectorUtil, TabData, TableData } from '@ddt-web/data-service';

@Component({
	selector: 'ate-widget-container',
	templateUrl: './widget-container.component.html',
	styleUrls: ['./widget-container.component.scss']
})
export class WidgetContainerComponent {
	@Input() public data: ComponentData;
	@Input() public rulesData: TableData;
	@Input() public selectedPortfolioIndex: number;
	private readonly areasToExploreKey: string = 'areas-to-explore';

	/**
	  * get all tabs for widgets
	  */
	public getTabIdForRules(): string[] {
		return (<any[]>ComponentDataSelectorUtil.cellRawValueSelector(this.rulesData, 'widgets', this.selectedPortfolioIndex) || []).map(widget => `areas-to-explore.${widget}`);
	}

	/**
	  *
	  * @param componentData tab data
	  * @param componentIdToMatch widget id
	  * check if widget tab data exists
	  */
	public isComponentIdMatched(componentData: TabData, componentIdToMatch: string): boolean {
		const extractedComponentId = componentData.config.id.replace(`${this.areasToExploreKey}.`, '');
		return extractedComponentId.startsWith(componentIdToMatch);
	}
}
